import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EMMALoadingComponent } from './emma-loading.component';

@NgModule({
  imports: [CommonModule],
  exports: [EMMALoadingComponent],
  declarations: [EMMALoadingComponent],
})
export class EMMALoadingModule {}
